/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListadoPacientesModelDto } from '../../models/listado-pacientes-model-dto';

export interface DoctoresPacientesControllerListadoPacientes$Params {

/**
 * Número máximo de analíticas a devolver
 */
  limit?: number;

/**
 * Paginación de los resultados
 */
  page?: number;

/**
 * Filtrar por nombre de usuario del paciente
 */
  nombreUsuario?: string;

/**
 * Filtrar por DNI del paciente
 */
  dni?: string;

/**
 * Filtrar por email del paciente
 */
  email?: string;

/**
 * Filtrar por teléfono del paciente
 */
  telefono?: string;

/**
 * Filtrar por nombre del paciente
 */
  nombreApellidos?: string;
  uuidPrograma?: string;
}

export function doctoresPacientesControllerListadoPacientes(http: HttpClient, rootUrl: string, params?: DoctoresPacientesControllerListadoPacientes$Params, context?: HttpContext): Observable<StrictHttpResponse<ListadoPacientesModelDto>> {
  const rb = new RequestBuilder(rootUrl, doctoresPacientesControllerListadoPacientes.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('page', params.page, {});
    rb.query('nombreUsuario', params.nombreUsuario, {});
    rb.query('dni', params.dni, {});
    rb.query('email', params.email, {});
    rb.query('telefono', params.telefono, {});
    rb.query('nombreApellidos', params.nombreApellidos, {});
    rb.query('uuidPrograma', params.uuidPrograma, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ListadoPacientesModelDto>;
    })
  );
}

doctoresPacientesControllerListadoPacientes.PATH = '/api/doctor-pacientes/listado-pacientes';
